import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'FieldTextarea'
export const group = ''

export default class ElFieldTextarea extends SectionProvider {
  constructor (options = {}) {
    super('ElFieldTextarea', options)

    this.name = name
    this.group = group
  }
}